import type { CashFlowPaymentStatus } from "../api/types/widgetTypes";

export const cashFlowPaymentStatusCaptionMap: Record<CashFlowPaymentStatus, string> = {
  Unpaid: "Unpaid",
  PartlyPaid: "Partially Paid",
  Paid: "Paid",
};
